enum actionTypes {
  FETCH_ASSETS = 'FETCH_ASSETS',
  FETCH_ASSETS_SUCCESS = 'FETCH_ASSETS_SUCCESS',
  FETCH_ASSETS_PENDING = 'FETCH_ASSETS_PENDING',
  FETCH_ASSETS_REJECTED = 'FETCH_ASSETS_REJECTED',
  UPDATE_ASSET = 'UPDATE_ASSET',
  TOGGLE_SELECTED_ASSETS = 'TOGGLE_SELECTED_ASSETS',
  FLUSH_ASSETS = 'FLUSH_ASSETS',
  ESCALATE_ASSETS = 'ESCALATE_ASSETS',
  SNOOZE_ASSETS = 'SNOOZE_ASSETS',
  SNOOZE_ASSETS_SUCCESS = 'SNOOZE_ASSETS_SUCCESS',
  RESOLVE_ASSET = 'RESOLVE_ASSET',
  RESOLVE_ASSET_SUCCESS = 'RESOLVE_ASSET_SUCCESS',
  RESET_FETCH_COUNT = 'RESET_FETCH_COUNT',
  DUMMY_ACTION = 'DUMMY_ACTION',

  SET_ASSETS_FILTERS = 'SET_ASSETS_FILTERS',
  SET_ASSETS_FILTERS_FIRST_TIME = 'SET_ASSETS_FILTERS_FIRST_TIME',
  SET_MISSING_ASSETS_FILTERS = 'SET_MISSING_ASSETS_FILTERS',
  SET_PLAYLISTS_FILTERS = 'SET_PLAYLISTS_FILTERS',
  SET_PLAYLISTS_FILTERS_FIRST_TIME = 'SET_PLAYLISTS_FILTERS_FIRST_TIME',
  RESTORE_FILTERS = 'RESTORE_FILTERS',
  SET_SCREEN_FILTERS = 'SET_SCREEN_FILTERS',
  SET_AGENTS_FILTERS = 'SET_AGENTS_FILTERS',
  SET_USER_FILTERS = 'SET_USER_FILTERS',
  UPDATE_FILTERS = 'UPDATE_FILTERS',
  SET_FILTERS = 'SET_FILTERS',

  DELETE_USER = 'DELETE_USER',
  DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS',
  FETCH_USERS = 'FETCH_USERS',
  FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS',
  FETCH_USERS_PENDING = 'FETCH_USERS_PENDING',
  FETCH_USERS_REJECTED = 'FETCH_USERS_REJECTED',
  SET_USERS = 'SET_USERS',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  SET_PASSWORD = 'SET_PASSWORD',

  ADD_USER_SUCCESS = 'ADD_USER_SUCCESS',
  ADD_USER = 'ADD_USER',
  UPDATE_USER = 'UPDATE_USER',
  UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS',
  UPDATE_USER_FAILED = 'UPDATE_USER_FAILED',
  UPDATE_USER_CHALLENGE_AND_SESSION = 'UPDATE_USER_CHALLENGE_AND_SESSION',

  AUTH_SUCCESS = 'AUTH_SUCCESS',
  AUTH_CHECK = 'AUTH_CHECK',
  AUTH_LOGOUT = 'AUTH_LOGOUT',

  FETCH_SCREENS = 'FETCH_SCREENS',
  FETCH_SCREENS_SUCCESS = 'FETCH_SCREENS_SUCCESS',
  FETCH_SCREENS_PENDING = 'FETCH_SCREENS_PENDING',
  ADD_SCREEN = 'ADD_SCREEN',
  ADD_SCREEN_SUCCESS = 'ADD_SCREEN_SUCCESS',
  UPDATE_SCREEN = 'UPDATE_SCREEN',
  UPDATE_SCREEN_SUCCESS = 'UPDATE_SCREEN_SUCCESS',
  UPDATE_SCREEN_FAILED = 'UPDATE_SCREEN_FAILED',
  DELETE_SCREEN = 'DELETE_SCREEN',
  DELETE_SCREEN_SUCCESS = 'DELETE_SCREEN_SUCCESS',
  UPDATE_SELECTED_SCREEN = 'UPDATE_SELECTED_SCREEN',
  UPDATE_SELECTED_SCREEN_SUCCESS = 'UPDATE_SELECTED_SCREEN_SUCCESS',

  FETCH_FEEDS = 'FETCH_FEEDS',
  FETCH_FEEDS_SUCCESS = 'FETCH_FEEDS_SUCCESS',
  FETCH_FEEDS_PENDING = 'FETCH_FEEDS_PENDING',

  LOGIN = 'LOGIN',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  BASIC_LOGIN = 'BASIC_LOGIN',
  BASIC_LOGIN_SUCCESS = 'BASIC_LOGIN_SUCCESS',
  LOGOUT = 'LOGOUT',
  LOGOUT_SUCCESS = 'LOGOUT_SUCCESS',

  FETCH_AGENTS = 'FETCH_AGENTS',
  FETCH_AGENTS_PENDING = 'FETCH_AGENTS_PENDING',
  FETCH_AGENTS_SUCCESS = 'FETCH_AGENTS_SUCCESS',
  FETCH_AGENTS_CANCEL = 'FETCH_AGENTS_CANCEL',
  ADD_AGENT = 'ADD_AGENT',
  UPDATE_AGENT_SUCCESS = 'UPDATE_AGENT_SUCCESS',
  UPDATE_AGENT = 'UPDATE_AGENT',
  DELETE_AGENT = 'DELETE_AGENT',
  DELETE_AGENT_SUCCESS = 'DELETE_AGENT_SUCCESS',

  FETCH_SKYNET_CONFIG = 'FETCH_SKYNET_CONFIG',
  FETCH_SKYNET_SUCCESS = 'FETCH_SKYNET_SUCCESS',
  UPDATE_SKYNET_CONFIG = 'UPDATE_SKYNET_CONFIG',
  UPDATE_SKYNET_CONFIG_SUCCESS = 'UPDATE_SKYNET_CONFIG_SUCCESS',

  SHOW_SNACKBAR = 'SNOW_SNACKBAR',
  HIDE_SNACKBAR = 'HIDE_SNACKBAR',

  GET_PLAYOUT_URLS = 'GET_PLAYOUT_URLS',

  FETCH_PLAYLISTS = 'FETCH_PLAYLISTS',
  FETCH_PLAYLISTS_SUCCESS = 'FETCH_PLAYLISTS_SUCCESS',
  FETCH_PLAYLISTS_PENDING = 'FETCH_PLAYLISTS_PENDING',
  FETCH_PLAYLISTS_REJECT = 'FETCH_PLAYLISTS_REJECT',
  SELECT_PLAYLIST = 'SELECT_PLAYLIST',
  DESELECT_PLAYLIST = 'DESELECT_PLAYLIST',
  RESET_PLAYLIST_FETCH_COUNT = 'RESET_PLAYLIST_FETCH_COUNT',
  ESCALATE_PLAYLIST = 'ESCALATE_PLAYLIST',
  SNOOZE_PLAYLIST = 'SNOOZE_PLAYLIST',
  RESOLVE_PLAYLIST = 'RESOLVE_PLAYLIST',

  SET_PLAYLIST_FILTER = 'SET_PLAYLIST_FILTER',
  UPDATE_PLAYLIST_FILTER = 'UPDATE_PLAYLIST_FILTER',

  FETCH_PLAYOUT_URLS = 'FETCH_PLAYOUT_URLS',
  FETCH_PLAYOUT_URLS_PENDING = 'FETCH_PLAYOUT_URLS_PENDING',
  FETCH_PLAYOUT_URLS_SUCCESS = 'FETCH_PLAYOUT_URLS_SUCCESS',
  UPDATE_PLAYOUT_FEEDS = 'UPDATE_PLAYOUT_FEEDS'
}
export default actionTypes;
